<template>
	<div id="app" :class="[curLan, { vertical: isMobile }]">
		<div class="float-bar">
			<div class="btn-language" ref="btn_lan" @click="activeSwitch = true" :class="{ active: activeSwitch, isMobile: isMobile }">
				<ul class="switch-languages" :class="{ active: activeSwitch }">
					<li :class="{ active: curLan == 'tc' }" @click.stop="changeLan('tc')"><span>繁體中文</span></li>
					<li :class="{ active: curLan == 'en' }" @click.stop="changeLan('en')"><span>ENGLISH</span></li>
					<li :class="{ active: curLan == 'ko' }" @click.stop="changeLan('ko')"><span>한국어</span></li>
					<li :class="{ active: curLan == 'ja' }" @click.stop="changeLan('ja')"><span>日本语</span></li>
				</ul>
			</div>
			<div class="btn-rule" @click="popOpen('rule')"></div>
			<div class="btn-share" @click="clickShare()"></div>
		</div>
		<div class="swiper main-swiper">
			<div class="swiper-wrapper">
				<!-- 首页 -->
				<div class="swiper-slide page page-enter active">
					<div class="center">
						<video
							v-if="!isMobile"
							class="bg-video"
							:src="bgVideo"
							preload="auto"
							autoplay
							loop
							muted="muted"
							webkit-playsinline="true"
							playsinline="true"
							x-webkit-airplay="allow"
							x5-video-player-type="h5"
							x5-video-player-fullscreen="true"
							x5-video-orientation="portraint"
							disablePictureInPicture
							controlslist="nofullscreen nodownload noremoteplayback noplaybackrate"
						></video>
						<div class="video-mask"></div>
						<div class="title"></div>
						<div class="btn-bind" @click="clickBind()"></div>
					</div>
				</div>
				<!-- 绑定页 -->
				<div class="swiper-slide page page-bind" :class="[stage]">
					<a class="page2-float" :href="currentEvent" target="_blank" @click="reportEvent()">
						<div class="gka-wrap">
							<div id="gka"></div>
						</div>
						<div class="float-txt"></div>
					</a>
					<div class="center">
						<div class="title"></div>
						<div class="page2-wrap">
							<div class="account-wrap">
								<div class="a1">
									<div class="t1">{{ $t('r3Account') }}</div>
									<div class="account-msg" :class="{ isLogin: userInfo }">
										<div class="icon icon-r3"></div>
										<div class="msg-right" v-if="userInfo && userInfo.role">
											<div class="nickname">{{ userInfo.role.roleName || userInfo.nickname }}</div>
											<div class="uid">UID:{{ userInfo.role.uid }}</div>
											<div class="btn-logout" @click="logout()">{{ $t('logout') }}</div>
										</div>
									</div>
									<div class="btn-login1" v-if="!userInfo" @click="login()">{{ $t('login') }}</div>
								</div>
								<div class="a2">
									<div class="t2">{{ $t('twitchAccount') }}</div>
									<div class="account-msg" :class="{ isLogin: twitchAccountMsg }">
										<div class="icon icon-twitch"></div>
										<div class="msg-right">
											<div class="nickname">{{ twitchAccountMsg.displayName }}</div>
											<div class="btn-logout" @click="twitchLogout()">{{ $t('logout') }}</div>
										</div>
									</div>
									<div class="btn-login2" v-if="!twitchAccountMsg" :class="{ active: userInfo }" @click="bindTwitch()">{{ $t('login') }}</div>
								</div>
							</div>
							<div class="btn-bind" @click="bind()" :class="{ active: twitchAccountMsg && userInfo && !isBInd }">{{ $t('bind') }}</div>
							<a class="btn-go" href="https://www.twitch.tv/directory/category/ninja-must-die" :class="{ active: isBInd }">{{ $t('enterTwitch') }}</a>
							<div class="btn-rule" @click="popOpen('rule')">{{ $t('readRule') }}</div>
						</div>
					</div>
				</div>
				<!-- faq页 -->
				<div class="swiper-slide page page-faq">
					<div class="center">
						<div class="title"></div>
						<div class="faq-wrap">
							<div class="qa" :class="{ active: index == qaActive }" v-for="(item, index) in $t('qaList')" :key="index">
								<div class="question" v-html="item.q" @click="qaClick(index)"></div>
								<div class="answer" v-html="item.a"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹窗 -->
		<sharePop></sharePop>
		<rulePop></rulePop>
		<successPop></successPop>
		<loginPop v-if="loginPopState"></loginPop>
		<shuPing></shuPing>
	</div>
</template>
<script>
	import { mapMutations, mapState } from 'vuex'

	import sharePop from '@/components/pop-share.vue'
	import rulePop from '@/components/pop-rule.vue'
	import successPop from '@/components/pop-success.vue'
	import loginPop from '@/components/loginIframe.vue'
	import shuPing from '@/components/shuping.vue'

	import Swiper from 'swiper'
	import { Mousewheel } from 'swiper/modules'
	import { params } from '@/lib/params.js'
	import db from '@/service/server.js'

	import 'swiper/css'
	import 'swiper/css/mousewheel'
	import { Toast } from './lib/toast'

	import eventBus from './lib/eventbus'

	import preloadImage from './lib/frame.js'

	import { gaReport } from './lib/monitor.js'
	import config from '@/config/config.js'

	let urllan = params(window.location.href, 'language')
	export default {
		name: 'App',
		data() {
			return {
				mainSwiper: null,
				activeSwitch: false,
				qaActive: -1,
				isBInd: false,
				bgVideo: require('@/assets/index-video.mp4'),
				isMobile: true
			}
		},
		computed: {
			...mapState(['curLan', 'userInfo', 'twitchAccountMsg']),
			stage() {
				if (this.isBInd) {
					return 'stage3'
				}

				if (this.userInfo && this.twitchAccountMsg) {
					return 'stage2'
				}

				return 'stage'
			},
			currentEvent() {
				if (this.curLan == 'tc') {
					return 'https://www.pandadagames.com/tc/news/652ce837b6329'
				}
				if (this.curLan == 'ja') {
					return 'https://www.pandadagames.com/ja/news/652ce7f64520d'
				}
				if (this.curLan == 'en') {
					return 'https://www.pandadagames.com/en/news/652ce7c34764a'
				}
				if (this.curLan == 'ko') {
					return 'https://www.pandadagames.com/ko/news/652ce7db6e699'
				}

				return 'https://www.pandadagames.com/tc/news/652ce837b6329'
			},
			loginPopState() {
				return this.$store.state.pop.login;
			}
		},
		mounted() {
			this.checkIsMobile()
			this.setScreen()
			document.addEventListener('click', this.bodyCloseMenus)

			this.mainSwiper = new Swiper('.main-swiper', {
				direction: 'vertical',
				slidesPerView: 1,
				mousewheel: true,
				modules: [Mousewheel]
				// initialSlide: 1
			})

			this.mainSwiper.on('slideChange', () => {
				this.activeSwitch = false
			})

			eventBus.$on('afterPopUpLogin', () => {
				this.afterLogin()
			})
			eventBus.$on('afterTokenInvalid', () => {
				this.logout()
			})
			//动画效果
			let frame = require('@imgs/frame.png')
			console.log('frame', frame)
			preloadImage([frame], function () {
				document.getElementById('gka').className += ' animation'
			})
			if (!this.userInfo) {
				let session = params(window.location.href, 'session')

				if (session && session != 'null') {
					this.updateState({
						name: 'session',
						value: session
					})
					this.afterLogin()
				} else {
					session = this.$store.state.session

					if (session) {
						this.afterLogin()
					}
				}
			} else {
				// 检查该账号是否有绑定twitch
				this.checkTwitch()
			}

			if (!this.twitchAccountMsg) {
				let code = params(window.location.href, 'code')
				let state = params(window.location.href, 'state')
				//todo loading页
				if (code && state) {
					this.mainSwiper.slideTo(1)
					db.getTwitchAccountMsg({
						code: code,
						state: state
					}).then((res) => {
						console.log('getTwitchAccountMsg res', res)
						if (res.data.code == 0) {
							this.updateState({
								name: 'twitchAccountMsg',
								value: res.data.data
							})
						} else {
							// // 获取当前页面的 URL
							// var url = new URL(window.location.href)

							// // 添加新的参数
							// url.searchParams.set('code', '')
							// url.searchParams.set('state', '')

							// // 将更新后的 URL 赋值给浏览器地址栏
							// window.history.replaceState({}, '', url.href)

							// Toast.showToast(res.data.msg, 2000)
							this.showApiErrMsg(res.data.code);
						}
						// 获取当前页面的 URL
						var url = new URL(window.location.href)

						// 添加新的参数
						url.searchParams.set('code', '')
						url.searchParams.set('state', '')

						// 将更新后的 URL 赋值给浏览器地址栏
						window.history.replaceState({}, '', url.href)
					})
				}
			}

			this.changeLan(urllan)
		},
		methods: {
			...mapMutations(['popOpen', 'popClose', 'updateState']),
			clickBind() {
				this.mainSwiper.slideTo(1)
				gaReport.bind(this.curLan)
			},
			clickShare() {
				this.popOpen('share')
				gaReport.share(this.curLan)
			},
			reportEvent() {
				gaReport.event(this.curLan)
			},
			checkIsMobile() {
				if (/iphone|android|ipod/i.test(navigator.userAgent.toLowerCase()) == true && params(location.search, 'from') != 'mobile') {
					this.isMobile = true
				} else {
					this.isMobile = false
				}
			},
			changeLan(lan) {
				if (!lan) {
					return
				}

				this.$root.$i18n.locale = lan
				this.updateState({
					name: 'curLan',
					value: lan
				})

				eventBus.$emit("changeLan")

				// 获取当前页面的 URL
				var url = new URL(window.location.href)

				// 添加新的参数
				url.searchParams.set('language', lan)

				// 将更新后的 URL 赋值给浏览器地址栏
				window.history.replaceState({}, '', url.href)

				const curConfig = config[lan];
				console.log(curConfig);
				if(curConfig) {
					document.title = curConfig['title'];
				}

				this.activeSwitch = false
			},
			logout() {
				this.updateState({
					name: 'userInfo',
					value: ''
				})

				// this.updateState({
				// 	name: 'twitchAccountMsg',
				// 	value: ''
				// })
				this.updateState({
					name: 'session',
					value: ''
				})

				this.isBInd = false
			},
			twitchLogout() {
				this.updateState({
					name: 'twitchAccountMsg',
					value: ''
				})
			},
			login() {
				// let lan2lan = {
				// 	tc: 'hant',
				// 	ja: 'ja',
				// 	en: 'en',
				// 	ko: 'ko'
				// }

				// let lan = lan2lan[this.curLan] || 'hant'
				// var target = ''
				// // if (process.env.NODE_ENV == 'production') {
				// 	// target = `https://webaccount.pandadagames.com/login?lang=${lan}&redirect_uri=`
				// // } else {
				// 	target = `https://webaccount-mirror.pandadagames.com/login?lang=${lan}&redirect_uri=`
				// // }
				// var redirect = encodeURIComponent(location.href)
				// location.href = target + redirect
				gaReport.login(this.curLan)
				this.popOpen('login')
			},
			checkTwitch() {
				db.getBindTwitch({
					uid: this.userInfo.role.uid
				}).then((res) => {
					if (res.data.code == 0) {
						if (res.data.data.exists) {
							this.isBInd = true
							this.updateState({
								name: 'twitchAccountMsg',
								value: res.data.data
							})
						}
					} else {
						this.showApiErrMsg(res.data.code);
					}
				})
			},
			bindTwitch() {
				if (!this.userInfo) {
					return
				}
				db.getAuthUrl({
					uid: this.userInfo.role.uid
				}).then((res) => {
					console.log('res', res)
					if (res.data.code == 0) {
						location.href = res.data.data.authUrl
					} else if (res.data.code == 10001) {
						this.showApiErrMsg(res.data.code);
						this.isBind = true
					} else if (res.data.code == 10002) {
						this.showApiErrMsg(res.data.code);
					} else if (res.data.code == 10010) {
						this.showApiErrMsg(res.data.code);
					}
				})
			},
			bind() {
				db.bind({
					uid: this.userInfo.role.uid,
					twitchID: this.twitchAccountMsg.twitchID
				}).then((res) => {
					if (res.data.code == 0) {
						this.isBInd = true
						this.popOpen('success')
					} else if (res.data.code == 10008 || res.data.code == 10016) {
						this.updateState({
							name: 'twitchAccountMsg',
							value: ''
						})

						// 获取当前页面的 URL
						var url = new URL(window.location.href)

						// 添加新的参数
						url.searchParams.set('code', '')
						url.searchParams.set('state', '')

						// 将更新后的 URL 赋值给浏览器地址栏
						window.history.replaceState({}, '', url.href)

						this.showApiErrMsg(res.data.code);
					} else if (res.data.code == 10010) {
						this.showApiErrMsg(res.data.code);
					} else if (res.data.code == 10011) {
						this.showApiErrMsg(res.data.code);
					}
				})
			},
			afterLogin() {
				db.getUserInfo().then(
					(res) => {
						console.log('res', res)
						if (res.data.code == 0) {
							this.updateState({
								name: 'userInfo',
								value: res.data.data
							})
							this.checkTwitch()
						} else {
							this.showApiErrMsg(res.data.code);
						}
					},
					(res) => {
						console.log('fail:', res)
					}
				)
			},
			setScreen() {
				this.setSize()
				window.addEventListener('resize', this.setSize)
			},
			setSize() {
				let width = null
				if (!this.isMobile) {
					width = document.documentElement.clientWidth > 1334 ? 1334 : document.documentElement.clientWidth
					let size = (width / 1334) * 625 + '%'
					document.querySelector('html').setAttribute('style', 'font-size:' + size)
				} else {
					let size = (document.documentElement.clientWidth / 750) * 625 + '%'
					document.querySelector('html').setAttribute('style', 'font-size:' + size)
				}
			},
			bodyCloseMenus(e) {
				let self = this
				if (self.$refs.btn_lan && !self.$refs.btn_lan.contains(e.target)) {
					if (self.activeSwitch == true) {
						self.activeSwitch = false
					}
				}
			},
			qaClick(ind) {
				if (this.qaActive == ind) {
					this.qaActive = -1
					return
				}
				this.qaActive = ind
			},
			showApiErrMsg(code) {
				const langConfig = config[this.curLan];
				const apiErrMsg = langConfig['apiErrMsg'];
				if (apiErrMsg[code]) {
					Toast.showToast(apiErrMsg[code], 2000)
				} else {
					Toast.showToast(langConfig['networkErr'], 2000)
				}
			}
		},
		components: {
			sharePop,
			rulePop,
			successPop,
			loginPop,
			shuPing
		}
	}
</script>
